// extracted by mini-css-extract-plugin
module.exports = {"image":"_37bc9e4"};